import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {ConsuntivoVolumiModel} from '../../../models/ConsuntivoVolumiModel';
import {ConsuntivoVolumiService} from './service-consuntivo-volumi/consuntivo-volumi.service';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {Router} from '@angular/router';
import {ProviderModel} from '../../../models/ProviderModel';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../../users/service/users.service';
import {FormControl, Validators} from '@angular/forms';
import * as toastr from 'toastr';
import {UpdateAllWorkflowStatusDialogComponent} from '../../archive/update-all-workflow-status-dialog/update-all-workflow-status-dialog.component';
import {ProjectConstants} from '../../project-constants';
import {DialogYearMonthComponent} from '../../general-components/dialog-year-month/dialog-year-month.component';
import {DialogSendEmailComponent} from '../../general-components/dialog-send-email/dialog-send-email.component';
import { debounceTime, delay, tap } from 'rxjs/operators';


@Component({
  selector: 'app-consuntivo-volumi',
  templateUrl: './consuntivo-volumi.component.html',
  styleUrls: ['./consuntivo-volumi.component.scss']
})
export class ConsuntivoVolumiComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isConsumptiveSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;

  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  isMocked: boolean;
  showFilter = true;

  offset: Offset;
  filter: ConsuntivoVolumiModel;
  numAnnoMeseData: any;
  contractTypeData: any;

  providerSelected: ProviderModel;

  workflowStatusFormControl: FormControl = new FormControl('valid', [
    Validators.required,
    Validators.pattern('valid'),
  ]);
  isEditing = false;
  editingRows: Array<any> = [];

  get workflowStatusList() {
    return new ProjectConstants().WORKFLOW_STATUS_LIST;
  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() reportSection?: boolean;
  @Input() isRecovery?: boolean;
  @Input() isArchive?: boolean;

  @Output() elementSelected = new EventEmitter();

  constructor(private consuntivoVolumiService: ConsuntivoVolumiService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router) {
    super();
    this.loaderService.display(true);

    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.sectionId = this.SECTIONS.MONTHLY_ACTUALS;
  }

  ngOnInit() {
    // this.loaderService.display(true);
    this.isConsumptiveSection = this.returnIsContractSection(this.router.url);
    this.selectedRowIndex = -1;
    this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;

    if (this.providerSelected.description === this.PROVIDER_IBM){
      if (this.isArchive) {
        this.displayedColumns = ['workflowStatus', 'numAnnoMeseRif', 'docType', 'regionDesc', 'localCustomerDesc', 
          'resourceUnitCod', 'resourceUnitName',  'designServicesDesc', 'unitsDesc', 'shareName','subsystem',
          'applicationDescription', 'vol', 'actions'];
      } else if (this.isRecovery) {
          this.displayedColumns = ['numAnnoMeseRif', 'regionDesc', 'localCustomerDesc', 'docType',
          'resourceUnitCod', 'resourceUnitName',  'designServicesDesc', 'unitsDesc', 'shareName',
          'applicationDescription', 'vol', 'actions'];
        } else {
          this.displayedColumns = ['numAnnoMeseRif', 'regionDesc', 'localCustomerDesc', 
          'resourceUnitCod', 'resourceUnitName',  'designServicesDesc', 'unitsDesc', 'shareName','subsystem',
          'applicationDescription', 'vol', 'actions'];
        }
    }else if(this.providerSelected.description.includes(this.PROVIDER_KYN)){
      if (this.isArchive) {
        this.displayedColumns = ['workflowStatus', 'numAnnoMeseRif', 'docType', 'srv', 'regionDesc', 'referenceRegion', 'servicesCountry', 'referenceCountry','billingCountry', 'localCustomerDesc', 'location',
          'resourceUnitCod', 'resourceUnitName',  'designServicesDesc', 'unitsDesc', 'shareName','subsystem', 'subsidary',
          'applicationDescription', 'vol', 'actions'];
      } else if (this.isRecovery) {
          this.displayedColumns = ['numAnnoMeseRif', 'regionDesc', 'localCustomerDesc', 'location', 'docType',
          'resourceUnitCod', 'resourceUnitName',  'designServicesDesc', 'unitsDesc', 'shareName',
          'applicationDescription', 'vol', 'actions'];
        } else {
          this.displayedColumns = ['numAnnoMeseRif', 'srv', 'regionDesc', 'referenceRegion', 'servicesCountry', 'referenceCountry','billingCountry', 'localCustomerDesc', 'location',
          'resourceUnitCod', 'resourceUnitName', 'currencyCod', 'designServicesDesc', 'unitsDesc', 'shareName','subsystem','subsidary',
          'applicationDescription', 'vol', 'actions'];
        }
    
   } else if (this.providerSelected.description === this.PROVIDER_DXC) {
        if (this.isRecovery) {
          this.displayedColumns = ['numAnnoMeseRecovery', 'serviceDate', 'docType', 'regionDesc', 'localCustomerDesc', 'contractTypeDesc',
          'resourceUnitCod', 'designServicesDesc', 'unitsDesc', 'vol', 'monthlyForecastQuantity'
          ];
        } else {
            this.displayedColumns = ['numAnnoMeseRif', 'serviceDate', 'docType', 'regionDesc', 'localCustomerDesc', 'contractTypeDesc',
            'resourceUnitCod', 'designServicesDesc', 'unitsDesc', 'vol', 'monthlyForecastQuantity'
          ];
        }
    } else {
      this.displayedColumns = ['serviceDate', 'numAnnoMeseRif', 'regionDesc', 'localCustomerDesc', 'contractTypeDesc',
        'resourceUnitCod', 'resourceUnitName',  'designServicesDesc', 'unitsDesc',
        'applicationDescription', 'serviceVariantCod', 'size', 'site',
        'numAnnoMeseAcceptance', 'ulbStatus', 'requestId', 'requestDescription',
        'instanceName', 'systemName', 'monthlyForecastQuantity', 'approverRequestor',
        'deviceNameServerName', 'actualQuantity', 'actions'];
    }

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.CONSUNTIVO_VOLUMI_OFFSET);
    this.getSessionStorageFilter();
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.init();
  }

  init() {
    // this.loaderService.display(true);
    this.filter.provider = this.providerSelected;
    this.filter.isRecovery = this.isRecovery;
    this.filter.docType = this.filter.isRecovery ? this.filter.docType : null;
    this.numAnnoMeseService.getAllMonth(this.providerSelected, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        const providerDefault = this.filter.provider;
        this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultYearMonth);

        console.log('first numannomese', this.filter.numAnnoMese);
        console.log('FILTRO:', this.filter);

        // if (!this.filter.numAnnoMese || !BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
        //   const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
        //   this.filter.numAnnoMese = numAnnoMese;
        // }

        if (!this.filter.numAnnoMese) {
          this.numAnnoMeseService.getLastConsumptiveVolMonth(this.providerSelected).subscribe(
            res => {
              this.filter.numAnnoMese = res;
              if (this.reportSection) {
                this.showFilter = true;
              } else {
                this.getDataPage(this.offset, this.filter);
              }
            }
          );
        } else {
          if (!this.reportSection) {
            // this.showFilter = false;
            console.log('vol anno mese ', this.filter.numAnnoMese);
            this.getDataPage(this.offset, this.filter);
          } else {
            this.showFilter = true;
          }
        }

      }, error => {
        console.log(error);
        // this.loaderService.display(false);
      });
      
  }

  getDataPage(offset: Offset, filter: ConsuntivoVolumiModel) {
    this.loaderService.display(true);
    const filterItem = this.getFilterItem();
    console.log('filter item get page volumi', filterItem);
    
    this.getPageSubscribe = this.consuntivoVolumiService.getPage(offset, filterItem).pipe(
      tap(() => this.loaderService.display(true)),
      debounceTime(0),
      delay(0),
      tap(() => this.loaderService.display(false)),
    ).subscribe(
        (resultPage: any) => {
          this.dataSource = resultPage.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = resultPage.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const consuntivoVolumi = this.dataSource.find(data => data.id === id) as ConsuntivoVolumiModel;
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(consuntivoVolumi.numAnnoMese)},
      {id: 'Reference Month', value: this.toCustomStringAnnoMese( consuntivoVolumi.numAnnoMeseRif)},
      {id: 'Doc Type', value: this.toCustomString(consuntivoVolumi.docType)},
      {id: 'Provider Cod', value: this.toCustomString( consuntivoVolumi.provider.cod)},
      {id: 'Provider Description', value: this.toCustomString( consuntivoVolumi.provider.description)},
      {id: 'Region Cod', value: this.toCustomString( consuntivoVolumi.region.description)},
      {id: 'Region Description', value: this.toCustomString( consuntivoVolumi.region.description)},
      {id: 'Local Customer Cod', value: this.toCustomString( consuntivoVolumi.localCustomer.cod)},
      {id: 'Local Customer Description', value: this.toCustomString( consuntivoVolumi.localCustomer.description)},
      {id: 'Contract Type Cod', value: this.toCustomString( consuntivoVolumi.contractType.cod)},
      {id: 'Contract Type Description', value: this.toCustomString( consuntivoVolumi.contractType.description)},
      {id: 'Resource Unit Cod', value: this.toCustomString( consuntivoVolumi.resourceUnit.cod)},
      {id: 'Resource Unit Name', value: this.toCustomString( consuntivoVolumi.resourceUnit.name)},
      {id: 'SL1 Cod', value: this.toCustomString( consuntivoVolumi.designServices.cod)},
      {id: 'SL1 Description', value: this.toCustomString( consuntivoVolumi.designServices.description)},
      {id: 'Units Cod', value: this.toCustomString(consuntivoVolumi.units ? consuntivoVolumi.units.cod : null)},
      {id: 'Units Description', value: this.toCustomString(consuntivoVolumi.units ? consuntivoVolumi.units.description : null)},
      {id: 'ShareName', value: this.toCustomString( consuntivoVolumi.shareName)},
      {id: 'Application Description', value: this.toCustomString(consuntivoVolumi.applicationDescription)},
      {id: 'Volume', value: this.toCustomString(consuntivoVolumi.vol)},
      {id: 'Is Balance', value: this.toCustomStringIs(consuntivoVolumi.isRecovery)},
      {id: 'Note', value: this.toCustomString(consuntivoVolumi.notes)}
      
    ];
    this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });
  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.CONSUNTIVO_VOLUMI_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);

  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered.filter;
    this.offset.actualQuantityFilter = dataFiltered.actualQuantityFilter;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  getCurrentElementWorkflowStatus(element: any) {
    if (element && element.workflowStatus && element.workflowStatus !== '') {
      return element.workflowStatus;
    } else {
      return 'NO_MAT_OPTION_SELECTED';
    }
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }

    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.VOLUME_CONSUMPTIVE_FILTER));
    this.filter = filter_ ? filter_ : new ConsuntivoVolumiModel();
  }

  onChangeWorkflowStatus($event, status, element) {
    if ($event && $event.isUserInput && status && element && element.workflowStatus && element.workflowStatus !== status) {
      console.log($event, status, element);
      if (!this.isEditing) {
        this.isEditing = true;
        this.editingRows = [];
      }
      element.workflowStatus = status;
      this.editingRows.push(element);
    }
  }

  updateWorkflowStatusSingle() {
    this.consuntivoVolumiService.updateWorkflowStatusSingle(this.editingRows).subscribe(
      (result: any) => {
        this.isEditing = false;
        toastr.success('Plains updated with success', 'Success');
        this.editingRows = [];
        this.getDataPage(this.offset, this.filter);
      }, error => {
        this.loaderService.display(false);
        toastr.error('A problem has occurred, please contact the Administrator', 'Error');
      }
    );
  }

  openMassiveWorkflowStatusEditDialog() {
    const volumeList = this.dataSource;
    const dialogRef = this.dialog.open(
      UpdateAllWorkflowStatusDialogComponent,
      {
        width: '40%',
        data: {
          volumeList
        }
      }
    );
  }

  openNotes(id: number) {
    const selectedData = this.dataSource.find(data => data.id === id);
    const list: GenericArray[] = [
      {id: 'Note', value: (!selectedData.notes) ? 'N.D.' : selectedData.notes}
    ];
    const note = true;
    const serviceType = 'volume';
    const discountData = selectedData; // per compatibilita' con il componente del dialog
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list, note, discountData, serviceType}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getDataPage(this.offset, this.filter);
    });
  }

  private getFilterItem() {
    const filterItem = this.filter;
    if (!this.isArchive) {
      filterItem.workflowStatus = undefined;
    }
    return filterItem;
  }

  // openTestDialog() {
  //   const dialogRef = this.dialog.open(DialogSendEmailComponent, {
  //   });
  // }

  checkConsolidation(): boolean {
    if (!this.dataSource || this.dataSource.length === 0) {
      return false;
    } else {
      if (this.dataSource.every(element => element.workflowClosed === true)) {
        return true;
      } else {
        return false;
      }
    }
  }

}

